import { useMutation } from "@tanstack/react-query";
import { useParams } from "react-router-dom";

import { ENDPOINTS } from "@/api/application-api";
import { useAuth } from "@/context/auth-context";
import { requestSmartTableCellReconciliation } from "@/queries/smart-tables/cellConvergence";
import { handleResponse } from "@/utils/errorResponseHandlers";
import { jsonAuthHeaders } from "@/utils/headers";

export const useCancelCell = () => {
  const userToken = useAuth()?.userToken ?? "";
  const { workspaceId } = useParams<{ workspaceId: string }>();
  const wid = Number(workspaceId);

  return useMutation<unknown, unknown, { tableId: string; sheetId: string; cellId: string }>({
    mutationFn: async ({ tableId, sheetId, cellId }) => {
      const response = await fetch(
        ENDPOINTS.smart_table_cell_cancel(wid, tableId, sheetId, cellId),
        {
          method: "POST",
          headers: jsonAuthHeaders(userToken),
        },
      );
      return handleResponse(response);
    },
    onSuccess: (_response, { tableId, sheetId }) => {
      requestSmartTableCellReconciliation({ tableId, sheetId, reason: "cancellation" });
    },
  });
};
